import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import {
  ActivityAwardRecordBo,
  ActivityAwardRecordVo,
  ActivitySubmitStatisticsVo,
  ActivityTaskCompleteRecordVo,
  ActivityUGCIndexVo,
  ActivityUserTaskCompleteRequest,
  UGCActivityRequest,
  UGCSubmitVideoRequest
} from './type';

// UGC活动提交视频
// POST /member/activity/submitVideo
// 接口ID：315922745
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-315922745
export const postUgcSubmitVideo = (data: UGCSubmitVideoRequest) =>
  request({
    url: '/member/activity/submitVideo',
    method: 'post',
    data
  });

// 获取活动信息
// GET /member/activity/index
// 接口ID：315922751
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-315922751
export const getUgcActivityInfo = (params: UGCActivityRequest): AxiosPromise<ActivityUGCIndexVo> =>
  request({
    url: '/member/activity/index',
    method: 'get',
    params
  });

// 任务完成记录
// POST /member/activity/taskCompleteRecord
// 接口ID：315922742
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-315922742
export const postUgcSubmitVideotaskCompleteRecord = (
  data: ActivityUserTaskCompleteRequest
): AxiosPromise<ActivityTaskCompleteRecordVo[]> =>
  request({
    url: '/member/activity/taskCompleteRecord',
    method: 'post',
    data
  });

// 获奖记录
// POST /member/activity/awardRecord
// 接口ID：315922748
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-315922748
export const postUgcActivityAwardRecord = (data: ActivityAwardRecordBo): AxiosPromise<ActivityAwardRecordVo[]> =>
  request({
    url: '/member/activity/awardRecord',
    method: 'post',
    data
  });

// 获取活动tab数量
// GET /activity/submitStatistics
export const getUgcRecordSubmitStatistics = (): AxiosPromise<ActivitySubmitStatisticsVo> =>
  request({
    url: '/member/activity/submitStatistics',
    method: 'get'
  });
